import { AxiosResponse } from "axios"

export const responseInterceptorSuccessCredentials = async (
  response: AxiosResponse
) => {
  return response
}

export const responseInterceptorErrorCredentials = async (error: any) => {
  if (error.response.status === 403) {
    console.log("No tiene permisos para realizar esta acción")
  } else {
    console.log("Comuníquese con soporte")
  }
  return Promise.reject(error)
}
